import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class GlobalDomEventService {
    public documentClickSubject: Subject<MouseEvent> =
        new Subject<MouseEvent>();
}
